import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "bg-light mb-2 py-1 px-2 shadow-sm rounded" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h5", { class: "py-2 mb-3 text-primary border-bottom" }, "Endereço", -1);
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-6" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, [
    /*#__PURE__*/ _createTextVNode("CEP "),
    /*#__PURE__*/ _createElementVNode("small", null, [
        /*#__PURE__*/ _createTextVNode("("),
        /*#__PURE__*/ _createElementVNode("a", {
            target: "_blank",
            href: "http://www.buscacep.correios.com.br/sistemas/buscacep/"
        }, "Não sei meu cep"),
        /*#__PURE__*/ _createTextVNode(")")
    ])
], -1);
const _hoisted_6 = { class: "col-6" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Estado", -1);
const _hoisted_8 = { class: "col-6" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Cidade", -1);
const _hoisted_10 = { class: "col-6" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Bairro", -1);
const _hoisted_12 = { class: "col-12" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Endereço", -1);
const _hoisted_14 = { class: "col-6" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Número", -1);
const _hoisted_16 = { class: "col-6" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("label", null, "Complemento", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_InputMasked = _resolveComponent("InputMasked");
    const _component_SelectUf = _resolveComponent("SelectUf");
    const _component_AutocompleteGenerico = _resolveComponent("AutocompleteGenerico");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_InputMasked, {
                    mask: "#####-###",
                    modelValue: _ctx.doacao.cep,
                    "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event) => ((_ctx.doacao.cep) = $event)),
                        _cache[1] || (_cache[1] = ($event) => (_ctx.changeCep()))
                    ],
                    required: ""
                }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_SelectUf, {
                    modelValue: _ctx.doacao.uf,
                    "onUpdate:modelValue": [
                        _cache[2] || (_cache[2] = ($event) => ((_ctx.doacao.uf) = $event)),
                        _cache[3] || (_cache[3] = ($event) => (_ctx.onChangeUf()))
                    ],
                    placeholder: "Estado onde você mora",
                    required: "",
                    tipo: "somente-estado"
                }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_AutocompleteGenerico, {
                    modelValue: _ctx.doacao.municipio_id,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.doacao.municipio_id) = $event)),
                    url: "/municipios/autocomplete",
                    "text-alias": "municipio",
                    placeholder: "Cidade onde você mora",
                    required: "",
                    pesquisaAdicional: {
                        uf: _ctx.doacao.uf,
                    }
                }, null, 8, ["modelValue", "pesquisaAdicional"])
            ]),
            _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.doacao.bairro) = $event)),
                    placeholder: "Informe o bairro onde você mora",
                    required: ""
                }, null, 512), [
                    [_vModelText, _ctx.doacao.bairro]
                ])
            ]),
            _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.doacao.logradouro) = $event)),
                    required: "",
                    placeholder: "Informe a rua/avenida onde você mora"
                }, null, 512), [
                    [_vModelText, _ctx.doacao.logradouro]
                ])
            ]),
            _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.doacao.numero) = $event)),
                    required: ""
                }, null, 512), [
                    [_vModelText, _ctx.doacao.numero]
                ])
            ]),
            _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.doacao.complemento) = $event)),
                    placeholder: "Exemplo: Bloco 15, AP 203"
                }, null, 512), [
                    [_vModelText, _ctx.doacao.complemento]
                ])
            ])
        ])
    ]));
}
